import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/helpers';
import useDashboardStore from '../store/useDashboardStore';

/**
 * Dual-Mode API Query Hook
 * - experimentalCaching ON: TanStack Query mit staleTime + refetchInterval
 * - experimentalCaching OFF: Gibt {data:null, isLoading:false} zurück - Legacy-Code übernimmt
 */
export function useApiQuery(queryKey, url, options = {}) {
  const experimentalCaching = useDashboardStore(s => s.experimentalCaching);
  const { enabled: callerEnabled, ...restOptions } = options;

  const result = useQuery({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
    queryFn: () => api(url),
    enabled: experimentalCaching && (callerEnabled !== false),
    staleTime: restOptions.staleTime || 30000,
    refetchInterval: restOptions.refetchInterval || false,
    ...restOptions,
  });

  // Wenn nicht optimiert: leeres Ergebnis - Legacy-useEffect im Caller übernimmt
  if (!experimentalCaching) {
    return { data: undefined, isLoading: false, error: null, refetch: () => {}, isOptimized: false };
  }

  return { ...result, isOptimized: true };
}

export function useInvalidateQueries() {
  const queryClient = useQueryClient();
  return (keyPrefix) => {
    queryClient.invalidateQueries({ queryKey: [keyPrefix] });
  };
}
